import {
    CREATE_DYEING_INWARD_DETAILS_REQUEST_DK,
    CREATE_DYEING_INWARD_DETAILS_SUCCESS_DK,
    CREATE_DYEING_INWARD_DETAILS_FAILURE_DK,
    DELETE_DYEING_INWARD_DETAILS_REQUEST_DK,
    DELETE_DYEING_INWARD_DETAILS_SUCCESS_DK,
    DELETE_DYEING_INWARD_DETAILS_FAILURE_DK,
    FETCH_SINGLE_DYEING_INWARD_DETAILS_REQUEST_DK,
    FETCH_SINGLE_DYEING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_DYEING_INWARD_DETAILS_FAILURE_DK,
    FETCH_DYEING_INWARD_DETAILS_REQUEST_DK,
    FETCH_DYEING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_DYEING_INWARD_DETAILS_FAILURE_DK,
    UPDATE_DYEING_INWARD_DETAILS_REQUEST_DK,
    UPDATE_DYEING_INWARD_DETAILS_SUCCESS_DK,
    UPDATE_DYEING_INWARD_DETAILS_FAILURE_DK,
    RESET_DYEING_INWARD_DETAILS_INFO_DK,
    CREATE_DYEING_INWARD_DETAILS_FORM_DK,
    UPDATE_DYEING_INWARD_DETAILS_FORM_DK,
    FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK,
    FETCH_PREVIOUS_DYEING_INWARD_DETAILS_REQUEST_DK,
    FETCH_PREVIOUS_DYEING_INWARD_DETAILS_SUCCESS_DK,
    FETCH_PREVIOUS_DYEING_INWARD_DETAILS_FAILURE_DK,
    DYEING_INWARD_DETAILS_PO_DETAILS_DISABLED_DK
} from './dyeingInwardDetails.actionsType';

export const DYEING_INWARD_DK_DETAILS = 'dyeingInwardDKDetails';

let initialState = {
    loading: false,
    dyeingInwardDetails: [],
    dyeingInwardDetailsWithoutId: [],
    previousGetList: [],
    dyeingInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldReceivingRolls: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0,
        fldPOQuantity: 0,
        fldInwardQuantity: 0,
        fldProcessLoss: 0,
        fldIsProcessLoss: false
    },
    isPoDetailsDisabled: false,
    selectedState: {},
    errorMessage: ''
};

export let dyeingInwardDKDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_DYEING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_PREVIOUS_DYEING_INWARD_DETAILS_REQUEST_DK:
        case CREATE_DYEING_INWARD_DETAILS_REQUEST_DK:
        case UPDATE_DYEING_INWARD_DETAILS_REQUEST_DK:
        case FETCH_SINGLE_DYEING_INWARD_DETAILS_REQUEST_DK:
        case DELETE_DYEING_INWARD_DETAILS_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_DYEING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardDetails: updatePayload
            };
        case FETCH_PREVIOUS_DYEING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload?.DYI
            };
        case FETCH_DYEING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsWithoutId: updatePayload
            };
        case DYEING_INWARD_DETAILS_PO_DETAILS_DISABLED_DK:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        case CREATE_DYEING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isPoDetailsDisabled: false
            };
        case UPDATE_DYEING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isPoDetailsDisabled: false
            };
        case FETCH_SINGLE_DYEING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsForm: updatePayload
            };
        case DELETE_DYEING_INWARD_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isPoDetailsDisabled: false
            };
        case RESET_DYEING_INWARD_DETAILS_INFO_DK:
            return {
                ...state,
                dyeingInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldReceivingRolls: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldProcessLoss: 0,
                    fldIsProcessLoss: false
                },
                isPoDetailsDisabled: false
            };
        case CREATE_DYEING_INWARD_DETAILS_FORM_DK:
        case UPDATE_DYEING_INWARD_DETAILS_FORM_DK:
            return {
                ...state,
                loading: false,
                dyeingInwardDetailsForm: {
                    ...state.dyeingInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_DYEING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_PREVIOUS_DYEING_INWARD_DETAILS_FAILURE_DK:
        case CREATE_DYEING_INWARD_DETAILS_FAILURE_DK:
        case UPDATE_DYEING_INWARD_DETAILS_FAILURE_DK:
        case FETCH_SINGLE_DYEING_INWARD_DETAILS_FAILURE_DK:
        case DELETE_DYEING_INWARD_DETAILS_FAILURE_DK:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
